import React from 'react';
import { Box } from '../../ui/core';

/**
 * The catalog is a make/model/year triple plus two model-level facts.
 * `sortField` is the API's sort key; here it matches the field name.
 */
export const FIELDS = [
  { key: 'make', label: 'Make', type: 'text', width: 150, sortable: true },
  { key: 'model', label: 'Model', type: 'text', width: 170, sortable: true },
  { key: 'year', label: 'Year', type: 'number', width: 90, sortable: true },
  { key: 'seatCount', label: 'Seats', type: 'number', width: 90, sortable: true },
  { key: 'type', label: 'Type', type: 'text', width: 170, sortable: true },
];

export const EligiblePill = ({ eligible }) => (
  <Box
    component="span"
    sx={{
      px: '9px',
      py: '3px',
      borderRadius: '999px',
      fontSize: '11.5px',
      fontWeight: 600,
      whiteSpace: 'nowrap',
      color: eligible ? 'success.main' : 'text.inactive',
      backgroundColor: (theme) =>
        eligible
          ? theme.palette.mode === 'dark'
            ? 'rgba(52,199,89,0.16)'
            : 'rgba(52,199,89,0.12)'
          : theme.palette.mode === 'dark'
          ? 'rgba(255,255,255,0.07)'
          : 'rgba(0,0,0,0.05)',
    }}
  >
    {eligible ? 'Eligible' : 'Retired'}
  </Box>
);

/** Only XL rows get a pill; the rest show a dash so the column scans fast. */
export const XlPill = ({ xl }) =>
  xl ? (
    <Box
      component="span"
      sx={{
        px: '9px',
        py: '3px',
        borderRadius: '999px',
        fontSize: '11.5px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        color: 'info.main',
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark' ? 'rgba(10,132,255,0.18)' : 'rgba(0,122,255,0.12)',
      }}
    >
      XL
    </Box>
  ) : (
    <Box component="span" sx={{ color: 'text.secondary' }}>
      —
    </Box>
  );
